if (!customElements.get('tsh-bitcoin-cart')) {
    customElements.define('tsh-bitcoin-cart', class extends HTMLElement {
      connectedCallback() {
        customElements.whenDefined('scala-cart-button').then(() => {
          if (!this.isConnected) return;
          const actions = this.closest('.cart__ctas');
          if (!actions) return;
          const button = actions.querySelector('scala-cart-button');
          if (button) {
            if (!this.contains(button)) this.append(button);
          } else {
            this.append(document.createElement('scala-cart-button'));
          }
        });
      }
    });
  }
